import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkOrderDetailsService } from './work-order-details.service';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderService {
  navigationShowDocumentMenu = false;
  navigationBackRoute = '';

  /** Minimum viewport width (px) required to use the document split view. */
  static readonly MIN_SPLIT_VIEW_WIDTH = 640;

  readonly showSplitView$ = new BehaviorSubject<boolean>(false);

  canUseSplitView(): boolean {
    return window.innerWidth >= WorkOrderService.MIN_SPLIT_VIEW_WIDTH;
  }

  setSplitView(show: boolean): void {
    if (show && !this.canUseSplitView()) {
      return;
    }
    if (this.showSplitView$.value !== show) {
      this.showSplitView$.next(show);
    }
  }

  toggleSplitView(): void {
    this.setSplitView(!this.showSplitView$.value);
  }

  constructor(private workOrderDetailsService: WorkOrderDetailsService) {}

  async load(id: string): Promise<void> {
    await this.workOrderDetailsService.initialize(id);
    await this.workOrderDetailsService.enableChangeDetection();
  }

  async refresh(): Promise<void> {
    await this.workOrderDetailsService.refresh();
  }

  dispose() {
    this.workOrderDetailsService.dispose();
  }
}
